<template>
  <div class="plan-complete mt-6">
    <div id="message" :title="title" class="m-4 text-center">
      <h2 class="text-2xl font-semibold leading-snug">
        <span class="block text-link">「{{ title }}」</span>
        <span class="block">{{ $t('tour_save_success') }}</span>
      </h2>
    </div>

    <div class="px-4">
      <a :href="questionnaire_url()" class="button-secondary w-full block button-icon icon-right" >
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
        <span>{{$t('tour_questionnaire_link')}}</span>
      </a>
    </div>

    <div id="control" class="mt-4 py-4 bg-light_gray border-t border-b border-section_border">
      <div class="px-4">
        <a class="button-secondary w-full block button-icon icon-left" @click="show">
          <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <span>{{ $t('tour_plan_link') }}</span>
        </a>
      </div>
      <div class="mt-4 px-4">
        <a class="button-secondary w-full block button-icon icon-left" @click="back">
          <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <span>{{ $t('tour_back_to_top') }}</span>
        </a>
      </div>
      <div class="mt-4 px-4">
        <a :href="tohoku_maas_url()" class="button-secondary w-full block button-icon icon-left">
          <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <span>{{ $t('tour_tohoku_maas_link') }}</span>
        </a>
      </div>
    </div>

  </div>
</template>

<script>
import router from '../router'
import Constants from '../constants'

export default {
  name: 'Complete',
  data () {
    return {
      id: this.$route.params.planId,
      tickets: []
    }
  },
  methods: {
    back: function () {
      router.push({ path: '/plans' })
    },
    show: function () {
      router.push({ name: 'plan', params: { id: this.id } })
    },
    tohoku_maas_url: function () {
      var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + '/'
    },
    questionnaire_url: function () {
      var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + '/questionnaire/THK0110'
    }

  },
  computed: {
    title: function () {
      return this.$store.getters['plans/getTitle']
    }
  },
  async created () {
    this.$store.dispatch('loading/beginLoading')
    await this.$store.dispatch('plans/fetchPlan', this.id)
      .then(() => {
        this.$store.dispatch('loading/endLoading')
      })
  }
}
</script>

<style scoped>
</style>
